import React from 'react';
import style from './spaced-section.module.less';
import classNames from 'classnames';
export const Spacer = ({ parent = 'sm', child = 'lg', className, children }) => {
    return (React.createElement("section", { className: classNames(style[`parent-${parent}`], style[`child-${child}`], className) }, children));
};
